export default __webpack_public_path__ + "static/media/location.96f53a29.svg";